// extracted by mini-css-extract-plugin
export var code = "hqwz8";
export var compact = "ITM-q";
export var image = "b10JS";
export var main = "iMtI5";
export var name = "TDo+d";
export var sample = "jT0X-";